import cc from 'classcat';

import styles from './styles.module.scss';
import { CloudinaryChart } from './CloudinaryChart';

export const MembershipHighlights = ({
  startWeight,
  goalWeight,
  planHighlights,
}) => {
  return (
    <div className={styles.componentWrapper}>
      <div className={styles.imageWrapper}>
        <CloudinaryChart />
      </div>
      <div className={styles.planHighlights}>
        <p className={styles.planTitle}>Membership includes:</p>
        <ul className={styles.planList}>
          {planHighlights.map(({ id, text, featured = false }) => {
            return (
              <li
                key={'highlight' + id}
                className={cc([
                  { [styles.featured]: featured },
                  styles.highlight,
                ])}
              >
                {text}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
